export enum ErrorCodes {
  NotFound = 404,
}